import { CreateOrUpdateBaseService } from "../../../../common/services/createOrUpdateBase.service";
import { services } from "../../../../constants/services";

export interface userData {
  id: number | null;
  email: string;
  isActive: boolean;
  lastName: string;
  name: string;
  password: string;
  passwordConfirmation: string;
  roleIds: number[];
  changePassword: any, // nuevo campo

}


export class CreateOrUpdatedUserCampusService extends CreateOrUpdateBaseService<userData, any> {
  // url = `${services.userCampus}/createOrUpdateUserCampus`;
  url = `${services.users}`;

};

